import Api from './Api'
import {
  SaveFavoriteList,
  SaveSingleFavorite,
} from '../../interfaces/favoriteInterface'

class Favorite extends Api {
  readonly urls = {
    getFavorites: '/Favorite/GetFavorites',
    getFavoritesDrug: '/Favorite/GetFavoritesDrug',
    saveAll: '/Favorite/SaveAll',
    save: '/Favorite/Save',
    // Gets the faves of another pharmacy
    getOtherFavorites: '/Favorite/GetOtherFavorites',
    // Gets all faves for admin
    getAllFavorites: '/Favorite/GetALLFavorites',
    remove: '/Favorite/Remove',
  }

  getFavoriteList = async (top: number, skip: number): Promise<any> => {
    let url = this.urls.getFavorites
    console.log(skip)
    if (skip || skip === 0) {
      url += `?$top=${top}&$skip=${skip * top}`
      url += `&$orderby=id desc`
    }

    const result = await this.postData(url)
    return result.data
  }

  getFavoriteDrugList = async (top: number, skip: number): Promise<any> => {
    let url = this.urls.getFavoritesDrug
    console.log(skip)
    if (skip || skip === 0) {
      url += `?$top=${top}&$skip=${skip * top}`
      url += `&$orderby=id desc`
    }

    const result = await this.postData(url)
    return result.data
  }

  

  saveFavoriteList = async (data: SaveFavoriteList): Promise<any> => {
    const result = await this.postJsonData(this.urls.saveAll, data)
    return result.data
  }

  saveSingleFavorite = async (data: SaveSingleFavorite): Promise<any> => {
    const result = await this.postJsonData(this.urls.save, data)
    return result.data
  }

  /// Gets the faves of another pharmacy
  getOtherFavorites = async (
    pharmacyKey: string,
    filter: string = '',
  ): Promise<any> => {
    let query =
      filter.length > 0
        ? `${this.urls.getOtherFavorites}?pharmacyKey=${pharmacyKey}&name=${filter}`
        : `${this.urls.getOtherFavorites}?pharmacyKey=${pharmacyKey}`
    query += `&$orderby=isInMyPharmacyDrug desc`
    const result = await this.postJsonData(query)
    return result.data
  }

  /// Gets all faves for admin
  getAllFavorites = async (): Promise<any> => {
    const result = await this.postJsonData(this.urls.getAllFavorites)
    return result.data
  }
  remove = async (data: number[]): Promise<any> => {
    const result = await this.postJsonData(this.urls.remove, data)
    return result.data
  }
}

export default Favorite
